module.exports = __webpack_public_path__ + "static/media/logo-green-2x.b3f2d7c6.png";